/* **************************************************** Finishing Shedule Door Data */
export interface FSDoorData {
    id: number;
}

export const mapFSDoorData = (data: any): FSDoorData => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSDoorData = {
        id: data.id,
    };

    return res;
};

export const mapFSDoorDatas = (data: any[]): FSDoorData[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSDoorData);
};


/* **************************************************** Finishing Shedule Door */
export interface FSDoor {
    id: number;
    fs_feature_id: number;
    category: string;
    location_name: string;
    location_id: number | null;
    data_door: FSDoorData[];
}

export const mapFSDoor = (data: any): FSDoor => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSDoor = {
        id: data.id,
        fs_feature_id: data.fs_feature_id,
        category: data.category,
        location_name: data.location_name,
        location_id: data.location_id || null,
        data_door: Array.isArray(data.data_door) ? mapFSDoorDatas(data.data_door) : [],
    };

    return res;
};

export const mapFSDoors = (data: any[]): FSDoor[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSDoor);
};
